import { mString } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import PayOnlineButton from 'components/Payments/payroc/PayOnlineButton';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

const Footer = ({
  step,
  amount,
  onClose,
  onRetry,
  status,
  isClosing = false,
  isRetrying = false
}) => {
  const { values } = usePaymentContext();
  const { handlePayment } = usePaymentContextApi();

  const isNewCard = step === 'credit-card';
  const canRetry = !isNewCard && (status === 'error' || status === 'canceled');

  if (status === 'success') return null;

  return (
    <div className="flex w-full items-center justify-between gap-3">
      <Button
        text={isNewCard ? 'Back' : 'Cancel'}
        variant="tertiary"
        size="large"
        textClassName="text-lg"
        className="h-12 px-8"
        isLoading={isClosing}
        isDisabled={isClosing}
        onClick={onClose}
      />

      {canRetry && (
        <Button
          text="Retry"
          icon="refresh-linear"
          size="large"
          textClassName="text-lg"
          className="h-12 px-8"
          isLoading={isRetrying}
          isDisabled={isRetrying || isClosing}
          onClick={onRetry}
        />
      )}

      {!isNewCard && values.methodDetail && (
        <Button
          text={`Pay ${mString(amount)}`}
          size="large"
          textClassName="text-lg"
          className="h-12 px-8"
          isDisabled={isRetrying || isClosing}
          onClick={handlePayment}
        />
      )}

      {isNewCard && <PayOnlineButton payrocId="pay-with-new-card" className="justify-end" />}
    </div>
  );
};

export default Footer;
